var _g, _g2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVerifPass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 58 58",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#556080"
    },
    d: "M29,0c0,0-6.667,8-22,8v19.085c0,9.966,4.328,19.577,12.164,25.735C21.937,55,25.208,56.875,29,58 c3.792-1.125,7.062-3,9.836-5.18C46.672,46.662,51,37.051,51,27.085V8C35.667,8,29,0,29,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4FBA6F"
    },
    d: "M29,51.661c-2.123-0.833-4.178-2.025-6.128-3.558C16.69,43.245,13,35.388,13,27.085V13.628 c7.391-0.943,12.639-3.514,16-5.798c3.361,2.284,8.609,4.855,16,5.798v13.457c0,8.303-3.69,16.16-9.871,21.018 C33.178,49.636,31.123,50.828,29,51.661z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M41.659,20.248c-0.416-0.364-1.047-0.321-1.411,0.094L26.951,35.537l-7.244-7.244 c-0.391-0.391-1.023-0.391-1.414,0s-0.391,1.023,0,1.414l8,8C26.481,37.895,26.735,38,27,38c0.011,0,0.022,0,0.033,0 c0.277-0.009,0.537-0.133,0.719-0.341l14-16C42.116,21.243,42.074,20.611,41.659,20.248z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifPass);
export default __webpack_public_path__ + "static/media/verifPass.7ad21df5ef054428bf85ce070cf55df7.svg";
export { ForwardRef as ReactComponent };